import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Dimmer, Form, Grid, Loader } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

import Date from '../../components/BaseComponents/Date';
import Select from '../../components/BaseComponents/Select';
import FormField from '../../components/BaseComponents';
import { MULTI_SELECT_TYPE } from '../../constants/columnTypes';

import { getLookupRequest } from '../../ducks/lookup';
import { exportProgressSelector, progressSelector } from '../../ducks/reports';
import { CLAIMS_REPORT_TYPE } from '../../constants/reportType';

const ClaimsReportFilters = ({
  params,
  setParams,
  onGenerateReport,
  onExportExcel,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const reportProgress = useSelector(progressSelector);
  const exportProgress = useSelector(exportProgressSelector);

  useEffect(() => {
    dispatch(getLookupRequest({ name: 'transportCompanies', isForm: true }));

    dispatch(
      getLookupRequest({
        entities: `reports/${CLAIMS_REPORT_TYPE}`,
        name: 'claimNumbers',
        isForm: true,
        isFilter: true,
      })
    );

    dispatch(
      getLookupRequest({
        entities: `reports/${CLAIMS_REPORT_TYPE}`,
        name: 'incidentType',
        isForm: true,
        isFilter: true,
      })
    );
  }, []);

  const handleChangeParams = (e, { name, value }) => {
    setParams(prev => ({ ...prev, [name]: value }));
  };

  return (
        <div className="report_params">
            <Form>
                <Grid>
                    <Grid.Row columns={4}>
                        <Grid.Column>
                            <Date name="startDate" value={params.startDate} onChange={handleChangeParams} />
                        </Grid.Column>
                        <Grid.Column>
                            <Date name="endDate" value={params.endDate} onChange={handleChangeParams} />
                        </Grid.Column>
                        <Grid.Column>
                            <Select
                                name="carrier"
                                text={t('ClaimsReport.Carrier')}
                                source="transportCompanies"
                                value={params.carrier}
                                onChange={handleChangeParams}
                            />
                        </Grid.Column>
                        <Grid.Column>
                            <FormField
                                name="claimNumbers"
                                text={t('ClaimsReport.ClaimNumbers')}
                                type={MULTI_SELECT_TYPE}
                                source="claimNumbers"
                                isPartialSelect
                                value={params.claimNumbers}
                                onChange={handleChangeParams}
                            />
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={4}>
                        <Grid.Column>
                            <Select
                                clearable
                                name="incidentType"
                                text={t('ClaimsReport.IncidentType')}
                                source="incidentType"
                                value={params.incidentType}
                                onChange={handleChangeParams}
                            />
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row columns={1}>
                        <Grid.Column verticalAlign="bottom" textAlign="right">
                            <Button primary onClick={onGenerateReport} disabled={reportProgress}>
                                <Dimmer active={reportProgress} inverted>
                                    <Loader size="small"></Loader>
                                </Dimmer>
                                Сформировать
                            </Button>
                            <Button primary onClick={onExportExcel} disabled={exportProgress}>
                                <Dimmer active={exportProgress} inverted>
                                    <Loader size="small"></Loader>
                                </Dimmer>
                                Скачать
                            </Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>
        </div>
    );
};

export default ClaimsReportFilters;
